class SnackInfo {
  constructor (app) {
    this.app = app
  }

  info = async (mess) => {
    this.app.snackbarMessage = mess
    this.app.snackbar = true
  }
}

const useSnackInfo = new SnackInfo()
export default useSnackInfo
